/* Sparkle & Space – header search extras: recent searches and closing the search after Add.
   Markup: snippets/ss-search-suggest.liquid, snippets/ss-search-item.liquid. */
(function () {
  if (window.ssSearch) return;
  var KEY = 'ss-recent-searches', MAX = 5;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M12 7.5V12l3 2" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function store(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} render(); }
  function remember(term) {
    term = (term || '').trim();
    if (term.length < 2) return;
    var list = load().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    store(list.slice(0, MAX));
  }
  function esc(s) { return s.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function render() {
    var list = load();
    var base = (window.routes && window.routes.search_url) || '/search';
    document.querySelectorAll('[data-ss-recent]').forEach(function (box) {
      box.hidden = !list.length;
      box.querySelector('[data-ss-recent-list]').innerHTML = list.map(function (t) {
        return '<li><a href="' + base + '?q=' + encodeURIComponent(t) + '">' + ICON + '<span>' + esc(t) + '</span></a>' +
          '<button type="button" data-ss-recent-remove="' + esc(t) + '" aria-label="Remove ' + esc(t) + ' from recent searches">×</button></li>';
      }).join('');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form[action*="/search"]')) remember((form.querySelector('input[name="q"]') || {}).value);
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    var rm = t.closest('[data-ss-recent-remove]');
    if (rm) {
      e.preventDefault();
      var term = rm.getAttribute('data-ss-recent-remove');
      store(load().filter(function (x) { return x !== term; }));
      return;
    }
    if (t.closest('[data-ss-recent-clear]')) { e.preventDefault(); store([]); return; }

    var ps = t.closest('predictive-search');
    if (!ps) return;
    var input = ps.querySelector('input[type="search"]');
    // Remember what led to a result, a chip or "See all".
    var chip = t.closest('[data-ss-sx-term]');
    if (chip) remember(chip.getAttribute('data-ss-sx-term'));
    else if (t.closest('.ss-sx-res a, .ss-sx-all__btn')) remember(input && input.value);
    // After Add, close the search so the cart drawer is visible.
    if (t.closest('.ss-sx-add')) {
      var modal = t.closest('details-modal');
      if (modal && typeof modal.close === 'function') setTimeout(function () { modal.close(false); }, 0);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
  window.ssSearch = { remember: remember };
})();
